<template>
    <div v-show="!modal_showing" class="cookie_card" @click="show_modal">
        <p>Politika upotrebe kolačića</p>
    </div>
</template>

<script>

    const app_url = window.APP_URL;

    export default {
        data: function () {
            return {
                modal_showing: false,
            };
        },
        methods: {
            show_modal: function () {
                this.modal_showing = true;
                this.$dialog.alert('<p style="line-height: 30px; text-align: center">U zavisnosti od Vašeg pristanka, kada to zahteva važeći zakon, digitalni mediji kojima upravlja STRAUSS ADRIATIC d.o.o ("digitalni mediji") koriste kolačiće i slične tehnologije ("kolačići"). Koristimo kolačiće kako bismo bolje razumeli kako posetioci koriste naše digitalne medije i pružene alate i usluge, kao i radi poboljšanja njihove upotrebe i funkcionalnosti. <a href="' + app_url + '/politika_upotrebe_kolacica' + '">Saznajte više</a><p>',
                    {
                        title: 'Politika upotrebe kolačića',
                        html: true,
                        okText: 'Nastavi',
                    }
                ).then(() => {
                    this.modal_showing = false;
                });
            },
            set_viewed_cookie_policy: function (value) {
                var d = new Date();
                d.setFullYear(d.getFullYear() - (-1));
                document.cookie = 'viewed_cookie_policy=' + value + ';expires=' + d.toUTCString() + ";path=/";
            }
        },
        computed: {
            viewed_cookie_policy: function () {
                return document.cookie.includes('viewed_cookie_policy=1');
            },
        },
        mounted: function () {
            if (!this.viewed_cookie_policy) {
                this.set_viewed_cookie_policy(1);
                this.show_modal();
            }
        }
    };
</script>

<style>
    .cookie_card {
        position: fixed;
        bottom: 0px;
        right: 100px;
        width: 200px;
        text-align: center;
        padding: 10px;
        background: white;
        border-width: 1px 1px 0px 1px;
        border-style: solid;
        border-color: grey;
        cursor: pointer;
        border-radius: 5px 5px 0px 0px;
        box-shadow: 2px 2px 5px 2px grey
    }

    .cookie_card p {
        font-size: 10pt;
        margin: 0px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CookiePolicyComponent.vue